// eslint-disable-next-line import/prefer-default-export
export const READING_LATEST_POST_SYSEND_EVENT =
  'READING_LATEST_POST_SYSEND_EVENT';
